export default {
  SMARTCHAT_DETAILS_UPDATE_PROCESS_DETAIL:      'SMARTCHAT_DETAILS_UPDATE_PROCESS_DETAIL',
  SMARTCHAT_DETAILS_UPDATE_MODAL_ACTION_REF:    'SMARTCHAT_DETAILS_UPDATE_MODAL_ACTION_REF',
  SMARTCHAT_DETAILS_SET_ACTION_DETAIL:          'SMARTCHAT_DETAILS_SET_ACTION_DETAIL',
  SMARTCHAT_DETAILS_UPDATE_ACTIONS_ERRORS:      'SMARTCHAT_DETAILS_UPDATE_ACTIONS_ERRORS',
  SMARTCHAT_DETAILS_UPDATE_MODAL_LOADING:       'SMARTCHAT_DETAILS_UPDATE_MODAL_LOADING',
  SMARTCHAT_DETAILS_UPDATE_MODAL_ERROR:         'SMARTCHAT_DETAILS_UPDATE_MODAL_ERROR',
  SMARTCHAT_DETAILS_UPDATE_LOADING:             'SMARTCHAT_DETAILS_UPDATE_LOADING',
  SMARTCHAT_DETAILS_UPDATE_ERROR:               'SMARTCHAT_DETAILS_UPDATE_ERROR'
}
